module.exports = __webpack_public_path__ + "static/media/icon-injury.1e7e7245.svg";